import {http_client} from "@/plugins/http_client";


const getPostulaciones = async(id, params) => await http_client('/api/v1/postulaciones/'+ id, params,'get')


export default{
    getPostulaciones
}